// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root__ihWbX","title":"Modal_title__3LTFy","buttons":"Modal_buttons__1ZC8K","button":"Modal_button__1Hix8","icon":"Modal_icon__33t4g"};